import { Box, IconButton, InputAdornment } from "@mui/material";
import TkLabelText from "../../../components/atoms/TkLabelText";
import TkButton from "../../../components/atoms/TkButton";
import TkCorporateSearchModal from "../../../components/molecules/TkCorporateSearchModal";
import TkResigneeSearchModal from "../../../components/molecules/TkResigneeSearchModal";
import { useContext, useEffect, useState } from "react";
import TkSelectForm from "../../../components/atoms/TkSelectForm";
import { TkGetCodeList } from "../../../utils/TkGetCode";
import {
  DomesticResidenceFlg,
  RetirementProvisionStatus,
} from "../../../assets/data/Constants";
import { useNavigate } from "react-router-dom";
import { httpAPI_CON001, httpAPI_RET019 } from "../api/request";
import { GlobalContext } from "../../../context/globalContext";
import TkDatePicker from "../../../components/atoms/TkDatePicker";
import { ClearIcon } from "@mui/x-date-pickers";

const SCRW070008SearchForm = (props: any) => {
  const { onSearch, defaultValue } = props;

  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const [cOpen, setCOpen] = useState(false);
  const [rOpen, setROpen] = useState(false);
  const [corpList, setCorpList] = useState<any>([]);
  const [selectedCorp, setSelectedCorp] = useState("");
  const [staffList, setStaffList] = useState<any>([]);
  const [selectedStaff, setSelectedStaff] = useState("");
  const [formValues, setFormValues] = useState<any>({});
  const [dateError, setDateError] = useState(false);

  useEffect(() => {
    if (defaultValue) {
      setFormValues(defaultValue);

      if (defaultValue.contractorName) {
        const value =
          defaultValue.contractorNo + ":" + defaultValue.contractorName;
        setSelectedCorp(value);
      }
      if (defaultValue.staffName) {
        const value = defaultValue.retireStaffNo + ":" + defaultValue.staffName;
        setSelectedStaff(value);
      }
    }
  }, [defaultValue]);

  const serchDialogOpen = () => {
    setCorpList([]);
    setCOpen(true);
  };

  const handleSearchCorp = async (event?: any) => {
    // 契約者一覧参照API 呼び出し
    try {
      const res = await httpAPI_CON001({
        contractorNo: event?.contractorNo,
        corpName: event?.corpName,
        prefectureCd: event?.prefectureCd,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        setCOpen(true);
        setCorpList(res.contractorList);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  const handleSaveCorp = (event: any) => {
    const value = (event?.contractorNo ?? "") + ":" + (event?.corpName ?? "");
    event && setSelectedCorp(value);

    setCOpen(false);
    setFormValues({
      ...formValues,
      contractorNo: event?.contractorNo,
      contractorName: event?.corpName,
    });
  };

  const handleSearchStaff = async (event: any) => {
    // 退職者検索API 呼び出し
    try {
      const res = await httpAPI_RET019({
        contractorNo: event.contractorNo,
        contractorName: event.contractorName,
        staffNo: event.staffNo,
        retirementStaffName: event.retirementStaffName,
        retirementStaffBirth: event.retirementStaffBirth,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        setStaffList(res.fileList);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  const handleSaveStaff = (event: any) => {
    const value =
      (event.staffNo ?? "") + ":" + (event.retirementStaffName ?? "");
    event && setSelectedStaff(value);

    setROpen(false);
    setFormValues({
      ...formValues,
      retireStaffNo: event?.staffNo,
      staffName: event?.retirementStaffName,
      contractorNo: event?.contractorNo,
    });
  };

  const handleChange = (field: any) => (event: any) => {
    const setStatusValue =
      event.target.value === "" || event.target.value === "null"
        ? null
        : event.target.value;
    const resObj = {
      ...formValues,
      [field]: setStatusValue,
    };
    setFormValues(resObj);
  };

  const handleSearch = () => {
    if (dateError) return;

    if (formValues.retireYears) {
      formValues.retireYears = formValues.retireYears.replace(
        /\/\d{2}$/,
        "/01"
      );
    }
    onSearch && onSearch(formValues);
  };

  const handleClear = () => {
    setSelectedCorp("");
    setFormValues({
      ...formValues,
      contractorNo: undefined,
      contractorName: undefined,
    });
  };

  const handleClearRe = () => {
    setSelectedStaff("");
    setFormValues({
      ...formValues,
      retireStaffNo: undefined,
      staffName: undefined,
      contractorNo: undefined,
    });
  };

  return (
    <Box className="SCRW070008">
      <Box className="searchForm">
        <TkLabelText
          wantToSetValue={selectedCorp}
          variant="standard"
          disabled
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleClear}
                  edge="end"
                  disabled={!!formValues.retireStaffNo}
                  sx={{ padding: 0.5, marginRight: 0.2 }}
                >
                  <ClearIcon sx={{ fontSize: 16 }} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TkButton
          onClick={serchDialogOpen}
          disabled={!!formValues.retireStaffNo}
        >
          法人検索
        </TkButton>

        <TkLabelText
          wantToSetValue={selectedStaff}
          variant="standard"
          disabled
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleClearRe}
                  edge="end"
                  disabled={!!formValues.contractorName}
                  sx={{ padding: 0.5, marginRight: 0.2 }}
                >
                  <ClearIcon sx={{ fontSize: 16 }} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TkButton
          onClick={() => setROpen(true)}
          disabled={!!formValues.contractorName}
        >
          退職者検索
        </TkButton>

        <TkSelectForm
          label="国内居住"
          selectPropsList={TkGetCodeList(DomesticResidenceFlg)}
          onChange={handleChange("domesticResidenceFlg")}
          wantToSetValue={defaultValue?.domesticResidenceFlg}
        />

        <TkDatePicker
          label="退職年月"
          views={["year", "month"]}
          format="YYYY / MM"
          minDate={new Date("1900-01-01")}
          maxDate={new Date("2099-12-31")}
          onChange={handleChange("retireYears")}
          onGetErrorFlg={setDateError}
          wantToSetValue={defaultValue?.retireYears}
        />

        <TkSelectForm
          label="状況"
          selectPropsList={TkGetCodeList(RetirementProvisionStatus)}
          onChange={handleChange("paymentStatus")}
          wantToSetValue={defaultValue?.paymentStatus}
        />

        <TkButton onClick={handleSearch}>検索</TkButton>
      </Box>

      <TkCorporateSearchModal
        open={cOpen}
        onClose={() => setCOpen(false)}
        onChangeSearchData={handleSearchCorp}
        onSave={handleSaveCorp}
        listData={corpList}
      />
      <TkResigneeSearchModal
        open={rOpen}
        onClose={() => setROpen(false)}
        onChangeSearchData={handleSearchStaff}
        onSave={handleSaveStaff}
        listData={staffList}
      />
    </Box>
  );
};

export { SCRW070008SearchForm };
